export default __webpack_public_path__ + "static/media/CreateBanner.08ee442f.png";